import type { Form } from '../../../services/formService';
import type { Task } from '../../../types/Task';
import { buildHiredEquipmentPdfFilename } from './hePdfFilename';

/**
 * Generates a hired equipment submission's vendor PDF on the server and downloads it – the
 * same endpoint and file name as Print PDF on the card. Used by the not-sent result after
 * *Approve and send* (V3-017). Throws when the PDF can't be generated.
 */
export async function downloadHiredEquipmentPdf(form: Form, availableTasks: Task[]): Promise<void> {
  const response = await fetch('/api/pdf/generate-hired-equipment-pdf', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ form, availableTasks }),
  });
  if (!response.ok) throw new Error('Failed to generate PDF');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = buildHiredEquipmentPdfFilename(form);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
